import { TranslationKeys } from '~/common/types';
import { SEARCH_FIELDS } from '@wyz/utils';
import { IBaseSearchFormSchema } from '~/purchase/types';

export const TYRE_AUTOCOMPLETE_SEARCH_FIELD_NAME_LOOKUP: Record<
  NonNullable<IBaseSearchFormSchema['fieldNameSearch']>,
  keyof TranslationKeys
> = {
  [SEARCH_FIELDS.EAN]: 'app.purchase.search_page.tyre_search_field.ean',
  [SEARCH_FIELDS.DIMENSION]:
    'app.purchase.search_page.tyre_search_field.dimension',
  [SEARCH_FIELDS.CAI]: 'app.purchase.search_page.tyre_search_field.cai',
  [SEARCH_FIELDS.REFERENCE]:
    'app.purchase.search_page.tyre_search_field.reference',
};
